import React from "react";
import { Steps, Row, Col } from "antd";
import "./style.scss";

export function StepComponent({ current, steps }) {
  return (
    <div className="master-main-container">
      <Row className="p-1">
        <Col lg={6} className="global-steps-container">
          <div
          // style={{
          //   padding: "20px",
          // }}
          >
            <Steps current={current} direction="vertical">
              {steps.map((item, idx) => (
                <Steps.Step
                  key={idx}
                  title={item.title}
                  description={item.description}
                />
              ))}
            </Steps>
          </div>
        </Col>
        <Col
          lg={18}
          // style={{
          //   display: "flex",
          //   justifyContent: "center",
          //   alignItems: "center",
          // }}
        >
          {steps.map((item, idx) => (
            <>
              <div
                key={idx}
                className={`steps-content  ${
                  item.step !== current + 1 && "hidden"
                }`}
              >
                {item.content}
              </div>
            </>
          ))}
        </Col>
      </Row>
    </div>
  );
}
